export const BASE_URL = (url) => {
  // let URL = `http://192.168.1.5:8081/monportail-internet-api/${url}`;
  // let URL = `http://testmomoagent.mtn.ci/monportail-internet-api/${url}`;
  let URL = `http://moninternet.mtn.ci/monportail-internet-api/${url}`;
  // let URL = `http://10.20.0.12:8080/monportail-internet-tubo-api/${url}`;
  // let URL = `http://10.18.37.186:8080/monportail-internet-api/${url}`;
  return URL
};

// homepage = http://moninternet.mtn.ci
// homepage test = http://10.18.37.186:8080/moninternet